// API Configuration
export const EXECUTE_URL = "/m4ai/api/v1/agent-systems/boschtestgap/execute?version=5";

// Queries
export const TESTCASE_QUERY = "Tell me gaps in the current testing of the function Smart home and fill these gaps. Therefore I want you to analyse the function and connected testcases, requirements, jira-tickets. In this case, no matter what the system prompt states your goal is it to find exact 6 gaps and return 6 new testcases. It is very improtant that you find and create 6 new testcases";
export const REVIEWS_QUERY = "Analyze the Amazon reviews (bosch.rezensionen) and identify gaps in the current testing coverage. Therefore I want you to analyze the reviews and existing testcases. In this case, no matter what the system prompt states, your goal is to extract real-world issues, user complaints, and quality problems from the reviews, and even if the data is not directly connected, use these insights to improve the testing. It is very important that you create new testcases based on the review findings and then generate Robot Framework code specifically for these new testcases. The Robot Framework tests must match the newly created testcases exactly.";

// UI Constants
export const TEXTAREA_CONFIG = {
  MAX_LINES: 8,
  LINE_HEIGHT: 24,
  get MAX_HEIGHT() { return this.MAX_LINES * this.LINE_HEIGHT; }, // 192px
  MIN_HEIGHT: '3rem'
};

// Animation Timings
export const ANIMATION_DURATIONS = {
  ROBOT_PRINT_DELAY: 25, // ms between lines when printing robot code
  STATE_RESET_DELAY: 50   // ms delay for state updates to complete
};

// Panel IDs
export const PANEL_IDS = {
  ANALYSIS: 'analysis',
  TESTCASES: 'testcases',
  ROBOT: 'robot'
};